const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      paddingTop: (props) => (props.headerHeight + 80),
      color: theme.colors[2],
    },
    cover: {
      extend: theme.wrapper,
      position: 'relative',
      zIndex: 1,
      marginBottom: 30,
      '& h1': {
        textTransform: 'uppercase',
        margin: 0,
        fontSize: 'calc(52px + 6vw)',
        color: theme.colors[4],
        fontFamily: theme.fonts[1],
        lineHeight: '0.9',
      },
    },
    wrap: {
      extend: theme.wrapper,
    },
    wrapPink: {
      background: theme.colors[4],
    },
    formWrap: {
      display: 'flex',
      marginBottom: 100,
    },
    formContent: {
      width: '50vw',
      paddingTop: 55,
      paddingBottom: 90,
      '& form': {
        justifyContent: 'center',
      },
    },
    formContentCenter: {
      margin: '0 auto',
    },
    formContentText: {
      fontSize: 21,
      color: theme.colors[2],
      marginTop: 60,
      '& a': {
        position: 'relative',
        color: theme.colors[2],
        '&:before': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: 1,
          background: theme.colors[2],
          bottom: 2,
          left: 0,
          transform: 'scaleX(0)',
          transformOrigin: 'left',
          transition: `transform 1s ${theme.easings['power4.out']}`,
        },
        '&:hover': {
          '&:before': {
            transform: 'scaleX(1)',
          },
        },
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    formContent: {
      width: '60vw',
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    cover: {
      '& h1': {
        fontSize: 'calc(30px + 4vw)',
      },
    },
    formContent: {
      width: '100%',
      paddingBottom: 90,
    },
    formContentText: {
      fontSize: 18,
      marginTop: 40,
    },
  }

  return output
}

export default style
